<template>
    <div :class="mClass">
      <a :href="mNbr" @click.prevent="aClick">{{content}}</a>
    </div>
</template>

<script>
export default {
  name: 'MhLink',
  props: ['mNbr', 'mLot', 'mCode', 'src', 'content', 'mObj', 'mType', 'mPara', 'mClass'],
  data () {
    return {
    }
  },
  computed: {
    linkType () {
      if ((this.mType) && (this.mType === 'link')) {
        return 'mnlink'
      } else {
        return 'sRouter'
      }
    },
    linkPara () {
      if (this.mPara) {
        return this.mPara
      } else {
        return {}
      }
    }
  },
  methods: {
    aClick: async function () {
      const that = this
      if (that.linkType === 'sRouter') {
        const stl = await that.$Any.getStaticRouterUrl(that.src, that.mNbr)
        const para = that.mPara || {}
        para.id = that.src
        para.nbr = that.mNbr
        para.lot = that.mLot || ''
        para.code = that.mCode || ''
        that.$Any.pushRouter(that.$router, stl, that.mNbr, para)
      } else {
        const para = that.linkPara
        para.id = that.src
        that.$router.push({
          name: that.src,
          params: para
          // eslint-disable-next-line handle-callback-err
        }).catch(err => {})
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .MhLinkBlack {
    a:link {
      color:black;
      text-decoration:none;
    }
    a:hover {
      color:black;
      text-decoration:underline;
    }
  }
  .MhLinkGreen {
    a:link {
      color:green;
      text-decoration:none;
    }
    a:hover {
      color:green;
      text-decoration:underline;
    }
  }
  .MhLinkRed {
    a:link {
      color:red;
      text-decoration:none;
    }
    a:hover {
      color:red;
      text-decoration:underline;
    }
  }
  .MhLinkBlue {
    a:link {
      color:blue;
    }
    a:hover {
      color:blue;
      text-decoration: underline;
    }
  }
  .MhLinkLightBlue {
    a:link {
      color:#fc8c23;
      text-decoration:none;
    }
    a:hover {
      color:#fc8c23;
      text-decoration:underline;
    }
  }
  .MhLinkYuHong {
    a:link {
      color:#c04851;
      text-decoration:none;
    }
    a:hover {
      color:#c04851;
      text-decoration:underline;
    }
  }
</style>
